export default ($window, $timeout) => ({
    restrict: 'AC',
    scope: false,
    link($scope, $elem, $attr) {
        if (!$window.Magic360) return;
        const doRefresh = () => $window.Magic360.start($elem[0]);
        const refresh = () => {
            $window.Magic360.stop($elem[0]);
            $timeout(doRefresh, 1000);
        }
        $elem.addClass('Magic360');
        refresh();
        $attr.$observe('href', href => refresh(href));
    }
});